export default "__VITE_ASSET__pADEGV0e5Qot5ZhzD_GrLg__ 200w, __VITE_ASSET__SH3JcDOvWNcn2WIvxBnLpg__ 500w, __VITE_ASSET__E8wuXQ_AmxPT2QBGX_$9Vw__ 1000w";